import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import Overview from './pages/Overview';
import PaymentReturn from './pages/PaymentReturn';
import SetupReturn from './pages/SetupReturn';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import OverviewRoute from './components/OverviewRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import './styles/global.css';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />

          <Route
            path='/admin'
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />

          <Route
            path='/dashboard'
            element={
              <PrivateRoute>
                <UserDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path='/overview'
            element={
              <OverviewRoute>
                <Overview />
              </OverviewRoute>
            }
          />

          <Route
            path='/payment-success'
            element={
              <PrivateRoute>
                <PaymentReturn />
              </PrivateRoute>
            }
          />

          <Route
            path='/setup-success'
            element={
              <PrivateRoute>
                <SetupReturn />
              </PrivateRoute>
            }
          />

          <Route path='/' element={<Navigate to='/dashboard' replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
